import { geocodeLocation } from '../helpers/geocodeLocation.api';
import { MapBounds } from '../components/MapView/components/GoogleMap/AuctionsNearMeGoogleMap';
import { useEffect, useState } from 'react';

type UseGeocodeLocationParams = {
    googleMapsReady: boolean;
    location: string | null;
};

type UseGeocodeLocationReturn = {
    bounds: MapBounds | null;
    failed: boolean;
    isGeocoding: boolean;
};

/**
 * Hook to geocode a location string and return the resulting bounds
 * Consolidates duplicate geocoding logic from custom search and custom geoArea flows
 */
export const useGeocodeLocation = ({
    googleMapsReady,
    location,
}: UseGeocodeLocationParams): UseGeocodeLocationReturn => {
    const [bounds, setBounds] = useState<MapBounds | null>(null);
    const [isGeocoding, setIsGeocoding] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!location || !googleMapsReady) {
            return;
        }

        const google = typeof window !== 'undefined' ? window.google : null;
        if (!google) {
            return;
        }

        const handleGeocode = async () => {
            setIsGeocoding(true);

            const result = await geocodeLocation(google, location);

            if (result) {
                setBounds(result);
                setFailed(false);
            } else {
                setFailed(true);
            }

            setIsGeocoding(false);
        };

        handleGeocode();
    }, [location, googleMapsReady]);

    return {
        bounds,
        failed,
        isGeocoding,
    };
};
